<template>
  <div class="agents-page">
    <ulu-agents-charts />
    <ulu-agents-stats />
  </div>
</template>

<script>
export default {
  components: {
    "ulu-agents-stats": () =>
      import("@/components/dashboard/agents/AgentsStats.vue"),
    "ulu-agents-charts": () =>
      import("@/components/dashboard/agents/AgentsCharts.vue"),
  }
};
</script>

<style scoped>
.agents-page {
  background-color: #f7f7f7;
  min-height: calc(100vh - 200px);
}
</style>
